var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.user)?_c('p',{staticClass:"base-section-title text-center title-sp"},[_vm._v(" "+_vm._s(_vm.$t("shared.hello"))+", "+_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name)+"! "+_vm._s(_vm.$t("shared.lets-started"))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }